import { z } from 'zod';

const SourceSchema = z.object({
  file: z.string().min(1),
  line: z.number().int().optional()
}).optional();

export const RouteDefinitionSchema = z.object({
  path: z.string().min(1),
  component: z.string().optional(),
  guards: z.array(z.string().min(1)).optional(),
  params: z.array(z.string().min(1)).optional(),
  source: SourceSchema
});

export type RouteDefinition = z.infer<typeof RouteDefinitionSchema>;
